import { useQuery } from '@tanstack/react-query';

import { getData } from 'api/requests/GET_DIPLOMA';

import { getQueryKey } from 'helpers/getQueryKey';

type Params = { id?: string };

export const getDiplomaURLOptions = (params: Params) => {
  const queryKey =
    params?.id === undefined
      ? getQueryKey('DIPLOMA_URL')
      : getQueryKey('DIPLOMA_URL', {
          id: params.id,
        });

  return {
    queryKey,
    queryFn: () => {
      if (params?.id !== undefined) {
        return getData(params.id);
      }

      return null;
    },
  };
};

export const useDiplomaUrl = (id?: string) => {
  return useQuery(getDiplomaURLOptions({ id }));
};
